import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ErrorCapture extends Vue {
  errorCaptured(error: Error) {
    console.error('errorCaptured', error)
    return false // prevent Nuxt from handling error
  }
}
